<template>
  <section v-if="error">
  <br/>
  <p class="error">{{ error }}</p>
  </section>
  <section class="page-container grid-container" v-if="!error && loaded">
    <div class="grid-container wizard">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.push('/')">← Back</a>
            </div>
        </div>
        </section>

        <section>
            <div class="grid-x grid-margin-x">
                <div class="cell small-12">
                    <h1 class="text-2xl font-bold">Direct Debit Mandate Setup Complete</h1>
                    <p>The below person has been provided as the direct debit authoriser for your company.</p>
                    <p>The direct debit mandate has now been completed.</p>
                    <table>
                    <thead>
                        <tr>
                        <th>Name</th>
                        <th>Job Title</th>
                        <th>Email Address</th>
                        </tr>
                    </thead>
                    <tbody v-if="_directDebitContact">
                    <tr>
                        <td>{{ _directDebitContact.firstName }} {{ _directDebitContact.lastName }}</td>
                        <td>{{ _directDebitContact.jobTitle }}</td>
                        <td>{{ _directDebitContact.email }}</td>
                    </tr>
                    </tbody>
                    </table>
                    <br/>
                    <button class="btn btn-secondary" @click="router.push('/')">Return to Home</button>
                </div>

            </div>
        </section>

        


</div>


  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useClientStore } from '@/stores/client'
import { useGoCardlessStore } from '@/stores/gocardless'
import { getDirectDebitMandateTask } from '@/services/implementationmanagement.api'
import { postGoCardlessComplete } from '@/services/gocardlessmandatemanager.func'
import { splitByCapitals } from '@/helpers/strings'
import { useRouter, useRoute } from 'vue-router'


const router  = useRouter()
const route = useRoute();
const loaded = ref(true);
const taskId = route.params.taskId 


const error = ref(null)
const task = ref(null)

// Add local variable to set payload to
const _directDebitContact = ref({})
const _ddTask = ref({})

const errorString = 'An error has occurred. Please contact your Qtac account manager.';


onMounted(async () => {
    const clientStore = useClientStore()



    // Get the first contact marked as Direct Debit Authoriser
    _directDebitContact.value = clientStore.contacts.find(c => c.isDirectDebitAuthoriser)



    try {
        var directDebitMandateTask = await getDirectDebitMandateTask(taskId);

        if(directDebitMandateTask.status !== 200 || directDebitMandateTask.data === null || directDebitMandateTask.data === undefined) {
            error.value = errorString;
            return null;
        }

        task.value = directDebitMandateTask.data;
        task.value.taskStatus = "SuccessfullyCompleted";

        // Get billingRequestId from querystring param
        const billingRequestId = route.query.billing_request_id;

        const response = await postGoCardlessComplete(task.value, taskId, billingRequestId);

        _ddTask.value = response.data;

        if (response.status !== 200) {
            error.value = 'Error saving data. Please contact your Qtac account manager.'
            return false
        }
        
    } catch (err) {
        error.value = errorString;
        console.error(err);
    }

loaded.value = true;
})


</script>

